/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./MicroAnimation.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-microAnimation");
exports.animationTypeArray = ["pulse"];
exports.getMicroAnimation = function (type) {
    switch (type) {
        case "pulse":
            return {
                name: "pulse",
                timeout: 1500,
                render: function () { return (React.createElement("div", null,
                    React.createElement("span", null))); }
            };
        default:
            throw new Error("Unknown MicroAnimation type \"" + type + "\"");
    }
};
var MicroAnimation = /** @class */ (function (_super) {
    tslib_1.__extends(MicroAnimation, _super);
    function MicroAnimation(props) {
        var _this = _super.call(this, props) || this;
        _this.done = _this.done.bind(_this);
        return _this;
    }
    MicroAnimation.prototype.shouldComponentUpdate = function (_a) {
        var play = _a.play;
        return this.props.play !== play;
    };
    MicroAnimation.prototype.componentDidMount = function () {
        if (this.props.play) {
            this.scheduleDone();
        }
    };
    MicroAnimation.prototype.componentWillUnmount = function () {
        if (this.doneTimeout) {
            clearTimeout(this.doneTimeout);
        }
    };
    MicroAnimation.prototype.componentWillReceiveProps = function (_a) {
        var play = _a.play;
        if (this.props.play !== play) {
            this.scheduleDone();
        }
        else if (!play && this.doneTimeout) {
            clearTimeout(this.doneTimeout);
        }
    };
    MicroAnimation.prototype.scheduleDone = function () {
        var timeout = exports.getMicroAnimation(this.props.type).timeout;
        if (this.doneTimeout) {
            clearTimeout(this.doneTimeout);
        }
        this.doneTimeout = window.setTimeout(this.done, timeout);
    };
    MicroAnimation.prototype.done = function () {
        if (this.props.onDone) {
            this.props.onDone();
        }
    };
    MicroAnimation.prototype.render = function () {
        var _a = this.props, type = _a.type, play = _a.play, className = _a.className, onDone = _a.onDone, props = tslib_1.__rest(_a, ["type", "play", "className", "onDone"]);
        var _b = exports.getMicroAnimation(type), name = _b.name, render = _b.render;
        return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName(), moduleClassName(name), play && moduleClassName(name + "-isPlaying"), className) }, props), render()));
    };
    MicroAnimation.propTypes = {
        type: PropTypes.oneOf(exports.animationTypeArray).isRequired,
        play: PropTypes.bool,
        onDone: PropTypes.func,
        className: PropTypes.string
    };
    MicroAnimation.defaultProps = {
        type: exports.animationTypeArray[0],
        play: false
    };
    return MicroAnimation;
}(React.Component));
exports.MicroAnimation = MicroAnimation;